import { IconFont } from '@/components/IconFont'
import OrbitAvatar from '@/components/OrbitAvatar'
import { getOrganizationList, leaveOrganization } from '@/services/organization/organization.service'
import { useRequest } from 'ahooks'
import { Button, Result, Row, Space, Typography, Modal } from 'antd'
import classnames from 'classnames'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import styles from './index.module.less'
const { Text } = Typography

export default memo(function OrganizationList() {
  const { data: list = [], loading, refresh } = useRequest(getOrganizationList)

  if (loading) {
    return null
  }

  const renderList = () => {
    return (
      <div className={'container-xl px-3'}>
        <Row justify={'end'}>
          <Link to={'../create'}>
            <Button icon={<IconFont type='icon-add' />} type={'primary'}>
              New Organization
            </Button>
          </Link>
        </Row>
        <div className={classnames(styles.content, 'mt-2')}>
          {list.map((item) => (
            <div className={styles.listItem} key={item.id}>
              <Space size={16}>
                <OrbitAvatar avatar={item.avatar} size='large' name={item.name} />
                <Link to={`../${item.id}`}>{item.name}</Link>
                <Text type='secondary'>{item?.personal ? 'Owner' : ''}</Text>
              </Space>

              <div
                onClick={() => {
                  Modal.confirm({
                    content: 'Are you sure to leave?',
                    onOk: async () => {
                      await leaveOrganization(item.id)
                      refresh()
                    }
                  })
                }}
              >
                <Button>Leave</Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const renderEmpty = () => {
    return (
      <div className={'center-container'}>
        <Result
          icon={<></>}
          title='This Space is empty. Create an organization to get started'
          extra={
            <Link to={'../create'}>
              <Button size={'large'} icon={<IconFont type='icon-add' />} type={'primary'}>
                New Organization
              </Button>
            </Link>
          }
        />
      </div>
    )
  }

  return <div className={classnames(styles.container, 'py-3')}>{!!list.length ? renderList() : renderEmpty()}</div>
})
